
$(document).ready(function () {
  $('#custom-email-loyalty').click(function (e) { 
    e.preventDefault();
    var email_value = $('input[name="contact[email]"]').val();
    window.location.href = "https://tveteshop.no/a/loyalty?email=" + email_value;
    
  });
if ($(window).width() < 600) {
         $($('.search-form__container')).appendTo($('#SiteHeader .page-width'));
    } 
});



if (window.location.href.indexOf("/loyalty") !== -1) {
var urlParams = new URLSearchParams(window.location.search);
    
    if (urlParams.has('email')) {
        var email = urlParams.get('email');
        $("#email").val(email);
    } else {
        console.log('Email parameter not found in the URL.');
    }
}